const REQUIRED_FIELDS = [
  "nation", "origin", "height", "weight", "todayFlag", "addressName",
];

export function normalizeHuaDaConfig(config) {
  if (!config || typeof config.version !== "string" || !config.version.trim()
    || !Array.isArray(config.products)) {
    throw new Error("项目配置不完整，请稍后重试");
  }
  const productIds = new Set();
  const products = config.products.map((product) => {
    const id = Number(product.productId);
    const price = Number(product.productPrice);
    if (!Number.isInteger(id) || id <= 0 || productIds.has(id)
      || product.productPrice === null || product.productPrice === ""
      || !Number.isFinite(price) || price <= 0 || price > 99999999.99 || !product.productName
      || !Array.isArray(product.requiredFields)
      || product.requiredFields.some((field) => !REQUIRED_FIELDS.includes(field))) {
      throw new Error("项目配置有误，请联系管理员");
    }
    productIds.add(id);
    return {
      id,
      name: product.productName,
      label: price,
      requiredFields: [...new Set(product.requiredFields)],
      sortOrder: Number(product.sortOrder) || 0,
      className: "flex-1",
      tag: "",
    };
  }).sort((a, b) => a.sortOrder - b.sortOrder);
  for (const field of ["orgId", "legacyRuleOrgId"]) {
    if (config[field] != null && (!Number.isSafeInteger(Number(config[field])) || Number(config[field]) <= 0)) {
      throw new Error("机构配置有误，请联系管理员");
    }
  }
  return { version: config.version, products, orgId: config.orgId, legacyRuleOrgId: config.legacyRuleOrgId };
}

// 缓存只恢复仍可售项目，标价始终以当前配置为准。
export function reconcileHuaDaRows(rows, products, orgId) {
  const productMap = new Map(products.map((product) => [Number(product.id), product]));
  const manualSumOrg = [1117, 1126, 1127, 1204].includes(Number(orgId));
  return rows.filter((row) => row && typeof row === "object").map((row) => {
    const previousProducts = Array.isArray(row.productList) ? row.productList : [];
    const previousTotal = sumHuaDaProducts(previousProducts);
    const hasManualSum = manualSumOrg && row.sum !== "" && row.sum != null
      && Number.isFinite(Number(row.sum)) && Number(row.sum) >= 0
      && (Number(orgId) === 1117 || row.manualSum === true
        || Math.abs(Number(row.sum) - previousTotal) > 0.005);
    const productIds = new Set();
    const selectedProducts = previousProducts.filter((product) => {
      const id = Number(product.productId);
      const valid = productMap.has(id) && !productIds.has(id);
      productIds.add(id);
      return valid;
    }).map((product) => ({
      productId: Number(product.productId),
      productCount: Number.isFinite(Number(product.productCount))
        ? Math.min(9999, Math.max(1, Math.floor(Number(product.productCount) || 1))) : 1,
      price: productMap.get(Number(product.productId)).label,
    }));
    const calculatedSum = sumHuaDaProducts(selectedProducts);
    return {
      ...row,
      productList: selectedProducts,
      manualSum: hasManualSum && selectedProducts.length > 0,
      sum: hasManualSum && selectedProducts.length ? row.sum
        : Number(orgId) === 1117 ? "" : calculatedSum,
    };
  });
}

// 以分累计，避免小数标价的浮点尾数被作为手填实付提交。
export function sumHuaDaProducts(products) {
  const cents = products.reduce((sum, product) => (
    sum + Math.round((Number(product.price) || 0) * 100) * (Number(product.productCount) || 0)
  ), 0);
  return cents / 100;
}
